import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ROOT } from '../../../constants/routes';
import styleRules from './styles';

const useStyles = makeStyles((theme) => createStyles(styleRules()));

const NauLogo = (): JSX.Element => {
  const { nauIcon } = useStyles();
  return (
    <Link to={'/'}>
      <Grid container item md={6} wrap="nowrap">
        <img className={nauIcon} height="22" src={`${ROOT}/Logo/NauIcon.svg`} alt={'naukotekaLogo'} />
        <img className={nauIcon} height="20" src={`${ROOT}/Logo/NauIconText.svg`} alt={'naukotekaTitle'} />
      </Grid>
    </Link>
  );
};

export default NauLogo;
